import React from "react";
import { CaretDown } from "shared/assets/icons";

import { Icon } from "shared/styles";
import { getStatus } from "shared/styles/defaults";
import { StyledDropdownIndicator, StyledValue } from "../styles";
import { ISelectValue } from "../types";

export const DefaultSelectValue: React.FC<ISelectValue> = ({ value, isOpen }) => {
  const { icon, iconStatus, label } = value;

  return (
    <StyledValue>
      {icon && <Icon as={icon} color={getStatus(iconStatus).iconColor} />}
      <span>{label}</span>
      <StyledDropdownIndicator isOpen={isOpen}>
        <CaretDown />
      </StyledDropdownIndicator>
    </StyledValue>
  );
};
